import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 10,
  d: "M6 18 18 6M6 6l12 12"
}


export default {
  __name: 'WizardIcon',
  props: { name: { type: String, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (__props.name === 'repeat')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("path", { d: "M17 2l4 4-4 4" }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("path", { d: "M3 11V9a3 3 0 0 1 3-3h15" }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("path", { d: "M7 22l-4-4 4-4" }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("path", { d: "M21 13v2a3 3 0 0 1-3 3H3" }, null, -1))
        ], 64))
      : (__props.name === 'utensils')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[4] || (_cache[4] = _createElementVNode("path", { d: "M4 3v8a2 2 0 0 0 2 2h1v8" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("path", { d: "M10 3v8" }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("path", { d: "M7 3v5" }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("path", { d: "M18 21V3c-2.2 0-4 2.7-4 6v4h4" }, null, -1))
          ], 64))
        : (__props.name === 'tag')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[8] || (_cache[8] = _createElementVNode("path", { d: "M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" }, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("circle", {
                cx: "8",
                cy: "8",
                r: "1.5"
              }, null, -1))
            ], 64))
          : (__props.name === 'card')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[10] || (_cache[10] = _createElementVNode("rect", {
                  x: "2",
                  y: "5",
                  width: "20",
                  height: "14",
                  rx: "2"
                }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("path", { d: "M2 10h20" }, null, -1))
              ], 64))
            : (__props.name === 'bell')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _cache[12] || (_cache[12] = _createElementVNode("path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }, null, -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("path", { d: "M10.3 21a1.9 1.9 0 0 0 3.4 0" }, null, -1))
                ], 64))
              : (__props.name === 'store')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _cache[14] || (_cache[14] = _createElementVNode("path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" }, null, -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("path", { d: "M3 6h18" }, null, -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("path", { d: "M16 10a4 4 0 0 1-8 0" }, null, -1))
                  ], 64))
                : (__props.name === 'invite')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _cache[17] || (_cache[17] = _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }, null, -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("circle", {
                        cx: "9",
                        cy: "7",
                        r: "4"
                      }, null, -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("path", { d: "M19 8v6" }, null, -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("path", { d: "M22 11h-6" }, null, -1))
                    ], 64))
                  : (__props.name === 'percent')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        _cache[21] || (_cache[21] = _createElementVNode("path", { d: "M19 5 5 19" }, null, -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("circle", {
                          cx: "6.5",
                          cy: "6.5",
                          r: "2.5"
                        }, null, -1)),
                        _cache[23] || (_cache[23] = _createElementVNode("circle", {
                          cx: "17.5",
                          cy: "17.5",
                          r: "2.5"
                        }, null, -1))
                      ], 64))
                    : (__props.name === 'banknote')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                          _cache[24] || (_cache[24] = _createElementVNode("rect", {
                            x: "2",
                            y: "6",
                            width: "20",
                            height: "12",
                            rx: "2"
                          }, null, -1)),
                          _cache[25] || (_cache[25] = _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "2"
                          }, null, -1)),
                          _cache[26] || (_cache[26] = _createElementVNode("path", { d: "M6 12h.01M18 12h.01" }, null, -1))
                        ], 64))
                      : (__props.name === 'check')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            _cache[27] || (_cache[27] = _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "10"
                            }, null, -1)),
                            _cache[28] || (_cache[28] = _createElementVNode("path", { d: "m9 12 2 2 4-4" }, null, -1))
                          ], 64))
                        : (__props.name === 'x')
                          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
                          : (__props.name === 'truck')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                _cache[29] || (_cache[29] = _createStaticVNode("<path d=\"M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2\"></path><path d=\"M15 18H9\"></path><path d=\"M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14\"></path><circle cx=\"17\" cy=\"18\" r=\"2\"></circle><circle cx=\"7\" cy=\"18\" r=\"2\"></circle>", 5))
                              ], 64))
                            : (__props.name === 'box')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                  _cache[30] || (_cache[30] = _createElementVNode("path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }, null, -1)),
                                  _cache[31] || (_cache[31] = _createElementVNode("path", { d: "M12 22V12" }, null, -1)),
                                  _cache[32] || (_cache[32] = _createElementVNode("path", { d: "m3.3 7 8.7 5 8.7-5" }, null, -1)),
                                  _cache[33] || (_cache[33] = _createElementVNode("path", { d: "m7.5 4.27 9 5.15" }, null, -1))
                                ], 64))
                              : (__props.name === 'pin')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                    _cache[34] || (_cache[34] = _createElementVNode("path", { d: "M20 10c0 5-5.5 10.2-7.4 11.8a1 1 0 0 1-1.2 0C9.5 20.2 4 15 4 10a8 8 0 0 1 16 0" }, null, -1)),
                                    _cache[35] || (_cache[35] = _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "10",
                                      r: "3"
                                    }, null, -1))
                                  ], 64))
                                : _createCommentVNode("", true)
  ]))
}
}

}